import { validator } from "@/utils/validator";
import { useMemo } from "react";
import {
  MAX_CHARACTER_INPUT_VALIDATION,
  MAX_CHARACTER_ZIP_CODE,
  MAX_COMPANY_ADDRESS_INPUT_VALIDATION,
  MAX_COMPANY_INPUT_VALIDATION,
  MAX_TEXT_INPUT_VALIDATION,
} from "@/constants/common";

export const useCompanyBranchSchema = () => {
  const companyBranchSchema = useMemo(() => {
    return validator.object().shape({
      branchName: validator.string().trim().emptyToNull().autoTransformToFullWidth().label("事業所名").required().max(MAX_COMPANY_INPUT_VALIDATION),
      telNumber: validator
        .string()
        .trim()
        .autoTransformToHalfWidth()
        .emptyToNull()
        .isTelNumber()
        .label("事業所代表電話番号")
        .max(MAX_CHARACTER_INPUT_VALIDATION)
        .nullable(),
      faxNumber: validator
        .string()
        .trim()
        .autoTransformToHalfWidth()
        .emptyToNull()
        .isTelNumber("FAX番号の形式が正しくありません。例：03-1234-5678 の形式で入力してください。")
        .label("FAX番号")
        .max(MAX_CHARACTER_INPUT_VALIDATION)
        .nullable(),
      zipCode: validator.string().emptyToNull().zipCode().autoTransformToHalfWidth().label("郵便番号").max(MAX_CHARACTER_ZIP_CODE).nullable(),
      prefecture: validator.string().trim().emptyToNull().label("都道府県").nullable(),
      city: validator.string().trim().emptyToNull().label("市区町村").nullable(),
      address: validator.string().trim().emptyToNull().label("町名丁目番地号等").max(MAX_COMPANY_ADDRESS_INPUT_VALIDATION).nullable(),
      branchDescription: validator.string().trim().emptyToNull().label("この事業所について").max(MAX_TEXT_INPUT_VALIDATION).nullable(),
    });
  }, []);

  return { companyBranchSchema };
};
